const MAX_SOURCE_BYTES = 12 * 1024 * 1024;
const MAX_EDGE = 1600;

/** Scales a camera photo to at most 1600px and re-encodes it as JPEG (typically 200–400 KB). */
export function compressPhoto(file: File): Promise<{ blob: Blob; name: string }> {
  if (!file.type.startsWith('image/')) return Promise.reject(new Error(`${file.name} is not an image.`));
  if (file.size > MAX_SOURCE_BYTES) return Promise.reject(new Error(`${file.name} is larger than 12 MB.`));
  return new Promise((resolve, reject) => {
    const source = new Image();
    const url = URL.createObjectURL(file);
    source.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, MAX_EDGE / Math.max(source.naturalWidth, source.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(source.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(source.naturalHeight * scale));
      canvas.getContext('2d')!.drawImage(source, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => (blob ? resolve({ blob, name: `${file.name.replace(/\.[^.]+$/, '')}.jpg` }) : reject(new Error(`Could not process ${file.name}.`))), 'image/jpeg', 0.78);
    };
    source.onerror = () => { URL.revokeObjectURL(url); reject(new Error(`Could not open ${file.name}.`)); };
    source.src = url;
  });
}
